import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./blog.css";
import blogData from "./blogData";

const DigitalMarketingKolkata = () => {
    const blog = blogData.find(
        (b) => b.slug === "digital-marketing-agency-kolkata"
    );

    useEffect(() => {
        AOS.init({ once: true });
        window.scrollTo(0, 0);
    }, []);

    if (!blog) {
        return (
            <section className="py-5">
                <div className="container">
                    <h2>Blog not found</h2>
                </div>
            </section>
        );
    }

    return (
        <>
            {/* HEADER */}
            <section className="blog-header">
                <div className="blog-circle yellow" />
                <div className="blog-circle teal" />
                <div className="blog-circle pink" />

                <div className="container">
                    <h2 data-aos="fade-up">{blog.title}</h2>
                    <p data-aos="fade-up" data-aos-delay="200">
                        {blog.excerpt}
                    </p>
                </div>
            </section>

            {/* BLOG DETAIL */}
            <section className="blog-detail py-5">
                <div className="container">
                    <div className="blog-layout">

                        {/* MAIN BLOG */}
                        <article className="blog-main" data-aos="fade-up">

                            <div className="blog-content-area">

                                <h1>Digital Marketing Agency in Kolkata</h1>

                                <p>
                                    Kolkata is one of India’s oldest and most culturally rich metropolitan cities,
                                    with a rapidly growing business ecosystem that includes manufacturing,
                                    education, healthcare, retail, IT services, real estate, and professional
                                    firms. As consumer behavior shifts toward digital platforms, businesses are
                                    increasingly looking for a reliable digital marketing agency in Kolkata to
                                    improve online visibility, generate consistent leads, and build sustainable
                                    growth.
                                </p>

                                <p>
                                    In a city where competition is rising across industries, digital marketing has
                                    become a key driver for customer acquisition. Businesses that adopt structured
                                    digital strategies are able to connect with their target audience, strengthen
                                    brand presence, and convert online interest into real business opportunities.
                                </p>

                                <img src={blog.image} alt={blog.title} />

                                <h2>Why Digital Marketing Matters for Businesses in Kolkata</h2>

                                <p>
                                    The Kolkata market is highly diverse, serving both local and national audiences.
                                    Customers today rely on Google searches, social media platforms, and online
                                    reviews before making purchasing decisions.
                                </p>

                                <p>Digital marketing helps Kolkata-based businesses to:</p>

                                <ul>
                                    <li>Reach customers actively searching for relevant products or services</li>
                                    <li>Improve brand visibility across digital channels</li>
                                    <li>Generate qualified leads with measurable outcomes</li>
                                    <li>Build credibility and trust in competitive markets</li>
                                    <li>Track performance and optimize campaigns using real data</li>
                                </ul>

                                <p>
                                    A professional digital marketing agency ensures that every campaign is aligned
                                    with business objectives and market demand.
                                </p>

                                <h2>Services Provided by a Digital Marketing Agency in Kolkata</h2>

                                <p>
                                    A full-service digital marketing agency offers integrated solutions that work
                                    together to support business growth.
                                </p>

                                <h2>Search Engine Optimization (SEO)</h2>

                                <p>
                                    SEO helps businesses improve their ranking on search engines like Google. By
                                    optimizing website content, technical structure, and keywords, SEO drives
                                    organic traffic and supports long-term visibility without continuous ad spend.
                                </p>

                                <h2>Google Ads & Performance Campaigns</h2>

                                <p>
                                    Google Ads enable businesses to appear at the top of search results instantly.
                                    With effective keyword targeting, ad optimization, and conversion tracking,
                                    paid campaigns help generate high-intent enquiries efficiently.
                                </p>

                                <h2>Social Media Marketing</h2>

                                <p>
                                    Social media platforms such as Facebook, Instagram, and LinkedIn allow
                                    businesses to engage with their audience directly. Strategic social media
                                    campaigns increase brand awareness, engagement, and lead generation.
                                </p>

                                <h2>WhatsApp Marketing & Customer Engagement</h2>

                                <p>
                                    WhatsApp has emerged as a fast and direct communication channel for businesses.
                                    Automated messages, broadcast campaigns, and follow-ups help businesses
                                    respond quickly and improve customer interaction.
                                </p>

                                <h2>Lead Generation Strategies</h2>

                                <p>
                                    Lead generation campaigns focus on capturing potential customer details
                                    through ads, landing pages, and forms. These leads can be nurtured through
                                    follow-ups and CRM workflows to improve conversion rates.
                                </p>

                                <h2>Website Optimization & User Experience</h2>

                                <p>
                                    A high-performing website plays a crucial role in digital marketing success.
                                    Agencies optimize website speed, mobile responsiveness, and layout to enhance
                                    user experience and increase enquiry conversions.
                                </p>

                                <h2>How a Digital Marketing Agency Helps Businesses Grow in Kolkata</h2>

                                <p>
                                    Effective digital marketing is driven by strategy, execution, and continuous
                                    improvement.
                                </p>

                                <ul>
                                    <li><b>Business analysis:</b> Understanding industry trends and competition</li>
                                    <li><b>Audience targeting:</b> Reaching users with high intent and relevance</li>
                                    <li><b>Creative development:</b> Crafting ads and content that attract attention</li>
                                    <li><b>Performance monitoring:</b> Tracking traffic, leads, and conversions</li>
                                    <li><b>Optimization:</b> Refining campaigns to improve ROI over time</li>
                                </ul>

                                <p>
                                    This structured approach ensures that marketing budgets are used efficiently
                                    and growth remains consistent.
                                </p>

                                <h2>Why Choose SMS ZOO ZOO as Your Digital Marketing Agency in Kolkata</h2>

                                <p>
                                    SMS ZOO ZOO is a performance-oriented digital marketing agency supporting
                                    businesses across India with scalable online growth strategies. Our focus is
                                    on delivering measurable outcomes that align with your business goals.
                                </p>

                                <p>What makes SMS ZOO ZOO a strong partner:</p>

                                <ul>
                                    <li>Customized digital marketing strategies for different industries</li>
                                    <li>Expertise in SEO, Google Ads, social media, and WhatsApp marketing</li>
                                    <li>Lead-focused campaigns designed for real business impact</li>
                                    <li>Transparent reporting and data-driven insights</li>
                                    <li>Dedicated consultation and ongoing support</li>
                                </ul>

                                <p>
                                    We understand the Kolkata business environment and build strategies that align
                                    with both local and broader market requirements.
                                </p>

                                <h2>Industries We Work With in Kolkata</h2>

                                <p>
                                    Our digital marketing services support businesses across a wide range of
                                    sectors, including:
                                </p>

                                <ul>
                                    <li>Education and training institutes</li>
                                    <li>Healthcare and clinics</li>
                                    <li>Manufacturing and industrial businesses</li>
                                    <li>Retail and e-commerce brands</li>
                                    <li>IT and professional services</li>
                                    <li>Real estate and service-based enterprises</li>
                                </ul>

                                <p>
                                    Each industry requires a tailored digital approach, and our strategies are
                                    designed accordingly.
                                </p>

                                <h2>Work with a Trusted Digital Marketing Agency in Kolkata</h2>

                                <p>
                                    In today’s competitive environment, businesses need digital strategies that
                                    deliver visibility, leads, and long-term growth. Partnering with an
                                    experienced digital marketing agency in Kolkata allows businesses to stay
                                    competitive, connect with the right audience, and expand their online
                                    presence.
                                </p>

                                <p>
                                    SMS ZOO ZOO combines strategic planning, creative execution, and performance
                                    tracking to help businesses turn digital opportunities into sustainable
                                    success.
                                </p>

                                <div className="blog-cta">
                                    <h3>📞 Contact us today to discuss your digital marketing goals</h3>
                                    <p>
                                        Let’s build a digital marketing strategy that supports consistent and
                                        measurable growth for your business in Kolkata.
                                    </p>

                                    <Link to="/contact_us" className="btn btn-dark">
                                        Contact Us
                                    </Link>
                                </div>
                            </div>
                        </article>

                        {/* RIGHT SIDEBAR */}
                        <aside className="blog-sidebar">
                            <h4>Latest Tags</h4>
                            <div className="blog-tags">
                                <span>Local SEO</span>
                                <span>Marketing</span>
                                <span>SEO</span>
                                <span>Content</span>
                            </div>

                            <h4 className="mt-4">Latest Posts</h4>

                            <div className="latest-posts">
                                {blogData.slice(5, 8).map((blog) => (
                                    <div className="latest-post-card" key={blog.id}>
                                        <div className="latest-post-img">
                                            <img src={blog.image} alt={blog.title} />
                                        </div>

                                        <div className="latest-post-content">
                                            <h5>{blog.title}</h5>
                                            <p>{blog.excerpt}</p>

                                            <Link to={`/blogs/${blog.slug}`} className="read-more">
                                                <span className="read-text">Read More</span>
                                                <span className="arrow-circle">
                                                    <i className="fas fa-arrow-up"></i>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </aside>

                    </div>
                </div>
            </section>
        </>
    );
};

export default DigitalMarketingKolkata;
